import React, { } from "react";
import { ConfirmModal } from "../..";
import { useMutation } from "@apollo/client";
import { UpdateServerResponse, UpdateServerArgs, UPDATE_SERVER } from "../../../Services/Agrisys_GqlDataCaller/ServiceToolCalls/GQLCalls/updateServer";

interface UpdateServerModalProps {
	closeModal: () => void;
	domain: string;
	version: string;
}

export default function UpdateServerModal({	closeModal, domain, version }: UpdateServerModalProps) {
	const [fetchData, { data, loading, error, reset}] = useMutation<UpdateServerResponse, UpdateServerArgs>(UPDATE_SERVER, {
		fetchPolicy: "no-cache",
		context: {
			headers: {
				tocloud: true
			}
		}
	});

	async function handleCommit() {
		await fetchData({ variables: { domain: domain, version }});
	}

	function handleCloseModal() {
		reset();
		closeModal();
	}

	return (
		<ConfirmModal
			disclaimer="This action will update the local servers version, this action is irreversible!"
			onCancel={handleCloseModal}
			onConfirm={handleCommit}
			message={
				(error || (data?.server && !data.server.updateServer?.success)) ? "ERROR: Failed to update version" :
				(!loading && !error && data?.server.updateServer?.success) ? "Succesfully updated version" : undefined
			}
			loading={loading}
		/>
	);
}